const base = "/ml-labor";
const path = {
  list: `${base}/processes`,
  options: `${base}/options`,
  optionsEvaluation: `${base}/options/evaluations`,
  evaluation: `${base}/evaluations`,
  modifications: `${base}/modifications`,
  indicators: `${base}/indicators`,
  plaintiffs: `${base}/plaintiffs`,
  listTypeFiles: `${base}/process-files/process`,
  listProcessFiles: `${base}/process-files/process`,
  saveProcessFiles: `${base}/process-files`,
  downloadFile: `${base}/process-files/generate-download-token`,
  deleteFile: `${base}/process-files`,
  historyFile: `${base}/process-files`,
};
export { path };
